import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlogService } from '../../../services/blog.service';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-lates-news',
  templateUrl: './lates-news.component.html',
  styleUrls: ['./lates-news.component.scss']
})
export class LatesNewsComponent implements OnInit {

  imageUrl!: string;
  contentTitle = 'Latest News - Xipe Tech';
  contentDescription = 'A leading software development company has unveiled a new framework that aims to simplify and enhance the software development process. The framework offers developers a range of tools and features designed to increase productivity and collaboration while reducing development time and costs.';
  contentKeywords = 'Technology Software, Web Development, API integration, PHP Development, Next.js development, React.js development, Node.js development, CMS Development, MVC Development, Android Application, iPhone Application, UI/UX Designing, UI Designing, 3D Designing, Logo Designing, Cloud computing, Artificial intelligence, Data analytics, Cybersecurity, Web development, Mobile app development, IT consulting, Virtual reality, Augmented reality, Web design Website development, Front-end development, Back-end development, Full-stack development, Responsive design, User interface (UI), User experience (UX), Custom web development, E-commerce development, Laravel development, Yii development, Codeigniter development, Content management systems (CMS), WordPress development, Drupal development, Magento development, Shopify development, Mobile-friendly websites, Cross-browser compatibility, Web application development, API integration, Website maintenance';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  blogs: any[] = [];
  meta: any;
  paginationLinks: any[] = [];
  constructor(private blogService: BlogService, private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {

    const baseUrl = window.location.origin;
    this.loadBlogs(1, 5);

    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }

  loadBlogs(page: number = 1, per_page: number): void {
    this.blogService.getBlogs(page, per_page).subscribe({
      next: (res) => {
        this.blogs = res.data;
        this.meta = res.meta;
        this.paginationLinks = res.meta.links;
      },
      error: (err) => console.error('Failed to load blog data:', err)
    });
  }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/noimage.png';
  }
}
